import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { CreativeSetEffects } from './creativeset.effects';

export function provideCreativeSetStore(): EnvironmentProviders {
    return importProvidersFrom(EffectsModule.forFeature(CreativeSetEffects));
}
